import {MediaUserLoginGuideDescription} from './description';
import {MediaUserLoginGuideHeading} from './heading';
import {MediaUserLoginGuideLinks} from './links';
import {MediaUserLoginLink} from './media-user-login-link';
import {MediaUserRegisterLink} from './media-user-register-link';
import {MediaUserLoginGuideRoot} from './root';

export const mediaUserLoginGuide = {
  root: MediaUserLoginGuideRoot,
  heading: MediaUserLoginGuideHeading,
  links: MediaUserLoginGuideLinks,
  mediaUserLoginLink: MediaUserLoginLink,
  mediaUserRegisterLink: MediaUserRegisterLink,
  description: MediaUserLoginGuideDescription,
};
